import { SortDescriptor } from '@progress/kendo-data-query';
import { UDViewTagSelectionEnum } from '../../../udView/udview';
import { dashboardFlightFilters } from '../../utils/dashboard';
import { DashboardFlightColumn, DashboardFlightsPanel } from './DashboardFlightsPanel';

const columns: DashboardFlightColumn[] = [
    { id: 'acid', field: 'normalizedAcid', title: 'Aircraft ID', tagSelector: UDViewTagSelectionEnum.Acid },
    { id: 'acType', field: 'aircraftType', title: 'AcType', tagSelector: UDViewTagSelectionEnum.AircraftType },
    { id: 'origin', field: 'origin', title: 'Origin', tagSelector: UDViewTagSelectionEnum.Origin },
    { id: 'destination', field: 'destination', title: 'Dest', tagSelector: UDViewTagSelectionEnum.Destination },
    { id: 'status', field: 'status', title: 'Status', tagSelector: UDViewTagSelectionEnum.Status }
];

const defaultSort: SortDescriptor[] = [{ field: 'normalizedAcid', dir: 'asc' }];

export function GoAroundFlightsList() {
    return (
        <DashboardFlightsPanel
            title="Go-Around flights"
            flightFilters={dashboardFlightFilters['go-around']}
            columns={columns}
            defaultSort={defaultSort}
            variant="go-around"
            emptyText="No go-around flights"
        />
    );
}
